export default "__VITE_ASSET__DmusmPrp__"